module.exports = __webpack_public_path__ + "static/media/09.56a956e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/09.jpg
// module id = 378
// module chunks = 0